import { getApiCurrentLanguage, getCurrentLanguage } from './functions';
import axios from "axios";

export const domain     = "https://dedalo.oroibidea.es";
const URL_SERVER        = domain+'/dedalo/lib/dedalo/publication/server_api/v1/json';
const db_name           = 'dedalo4_public';
const code              = 'inm3014rtAw_testimonios';
const records           = '/records';
const language          = getApiCurrentLanguage();
export const base_path  = 'cautividad'//'/dispromedia/web_centros_detencion';

export async function getGroupsMarkers(){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=parent%3D%22navarra106_2%22"+
        "&lang=lg-"+language
    );
}

export async function getMapsMarksByParent(parent){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&ar_fields=[\"space\", \"space_geojson\", \"term\", \"term_id\", \"identify_image\"]"+
        "&order=space_geojson"+
        "&sql_filter=parent%3D%22"+parent+"%22"+
        "&lang=lg-"+language
    );
}

export async function getExplore(id, onlyTitle = false){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        (onlyTitle ? "&ar_fields=[\"term\", \"term_id\"]" : "")+
        "&order=norder"+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=parent%20%3D%20%22"+id+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getExploreTerm(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=term_id%3D%22"+id+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getImageData(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=image"+
        "&section_id="+id+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getMenu(){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&ar_fields=[\"menu\", \"term\", \"web_path\"]"+
        "&table=ts_centros_detencion_pamplona"+
        "&order=norder"+
        "&sql_filter=menu%3D%22yes%22%20and%20parent%20%3D%20%22hierarchy1_278%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}


export async function getReport(lang){
    var term = 'navarra106_181'
    if (lang === "es") term = "navarra106_181"
    if (lang === "eu") term = "navarra106_182"
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&ar_fields=[\"pdf_resolved\"]"+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=parent%3D%22navarra106_63%22%20AND%20term_id%3D%22"+term+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getTerms(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=parent%3D%22"+id+"%22"+
        "&order=norder"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getTerm(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=term_id%3D%22"+id+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getParents(currentId){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&ar_fields=parents"+
        "&sql_filter=term_id%3D%22"+currentId+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getParent(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=term_id%3D%22"+id+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}

export async function getCredits(id){
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_centros_detencion_pamplona"+
        "&sql_filter=term_id%3D%22"+id+"%22"+
        "&lang=lg-"+language+
        "&limit=0"
    );
}